import React from 'react'

import {FaToggleOn } from 'react-icons/fa'
import { MdOutlineNotifications, MdOutlineRocket} from 'react-icons/md'
import piggy_serv from '../../piggy_serv.png'
import target_serv from '../../target_serv.png'
import krabs_serv from '../../krabs_serv.png'
export default function Details() {
  return (
    <div className='flex flex-col gap-[1em] lg:grid lg:grid-cols-3 font-[Lexend] mb-[10em]'>

        <div className="flex flex-col w-[90%] ml-[1.5em] bg-[rgba(239,232,226,1)] h-[30em] rounded-md p-[3em]">
        <p className='text-xl font-bold mb-[1em]'>Track Transactions</p>
        <p>Building a platform where we manage rent for landlords to make paying rent easier for tenants and reduce pressure.</p>
        <img src={piggy_serv} alt=''></img>
        </div>

        <div className="flex flex-col-reverse lg:ml-0 ml-[1.75em]  gap-[1em] w-[90%] ">

        <div className='bg-[rgba(239,232,226,1)]  h-[14em] rounded-md px-[2em] py-[3em]'>
            
        <img src={target_serv} className=' relative -top-[1em] left-[40%] lg:-top-[1em] lg:left-[14.5em] object-cover bg-[inherit] w-[7em] h-[5em]' alt=''></img>
        <p className='text-xl font-bold mb-[1em] -mt-[1em] lg:-mt-[2em]'>Target Management</p>
        <p className='font-light'>Our platform helps you hit your monthly targets.</p>
        </div>
        
        <div className='bg-green-500 text-white h-[14em] rounded-md px-[2em] py-[3em] '>
            
        <img src={krabs_serv} className='h-[6em] relative left-[65%] -top-[2.25em] lg:left-[12em] lg:-top-[2em]' alt=''></img>
        <p className='text-xl font-bold mb-[1em] -ml-[1em] lg:ml-0 -mt-[3em] lg:-mt-[3em] '>Manage Account</p>
        <p className='font-light -ml-[1em]'>Building a platform where we manage rent for landlords.</p>
        </div>

        </div>
     
        <div className="flex flex-col w-[90%] bg-[rgba(239,232,226,1)] ml-[1.5em] lg:mr-[1.5em] lg:h-[30em] rounded-md py-[2em] px-[1em] h-[25em] lg:p-[3em]">

        <p className='text-base lg:text-xl font-bold mb-[1em]'>Fast Notification and payment</p>
        <p className='text-sm'>You pay in seconds and get notified as soon as possible</p>

         <div className="-ml-[.3em] bg-white p-[2em] mt-[1em] lg:mt-[2em] w-full lg:w-[110%] rounded-xl flex flex-col gap-[3em]">
        
        
                      <div className="flex flex-row justify-between">
                        <MdOutlineNotifications className='lg:text-2xl text-3xl text-green-500 rounded-full'/>
                        <div className="flex flex-col -mt-[.75em] ml-[1em]">
                          <p className='text-sm font-bold'>Instant Notifications</p>
                          <p  className='text-xs font-normal w-[100%] '>Recieve instant notifications for all transactions</p>
                        </div>
                          <FaToggleOn className='hidden text-green-700 text-2xl mt-[.em] ml-[1em]'/>
                          
                      </div>
                     
                      <div className="flex flex-row gap-[1em]">
                        <MdOutlineRocket className='text-purple-500 lg:text-2xl text-3xl rounded-full'/>
                        <div className="flex flex-col -mt-[.75em] ">
                          <p className='text-sm font-bold '>Fast payment</p>
                          <p  className='text-xs font-normal w-[100%]'>Monitor your growth and payment</p>
                        </div>
                          <FaToggleOn className='hidden text-green-700 text-2xl mt-[.em] ml-[1em]'/>
                          
                      </div>
                     
                     
                     
                     
                     </div>
               
        </div>
    </div>
  )
}
